import {
  CustomGroupSectionNode,
  CustomSectionNodeType,
} from 'api/custom-section/types';
import { JSONContent } from 'api/page-template/types';

export const isCustomGroupSection = (
  node: JSONContent,
): node is CustomGroupSectionNode => {
  return node.type === CustomSectionNodeType.RlGroupSection;
};
export const getNumberOfCustomGroupSections = (json: JSONContent): number => {
  return json.content?.filter(isCustomGroupSection).length ?? 0;
};
export const findCustomGroupSectionIndex = (
  json: JSONContent,
  target: CustomGroupSectionNode,
): number => {
  return (
    json.content?.filter(isCustomGroupSection).findIndex((node) => {
      const targetAttrs = target.attrs;

      if (targetAttrs.templateSectionId != null) {
        return node.attrs?.templateSectionId === targetAttrs.templateSectionId;
      }
      if (targetAttrs.documentSectionId != null) {
        return node.attrs?.documentSectionId === targetAttrs.documentSectionId;
      }

      return false;
    }) ?? -1
  );
};
